import Solo from './customer/default/solo.component';

export default Solo;
